const instaLink = 'https://www.instagram.com/pk_pranavv/'
const fbLink = 'https://www.facebook.com/pranav.kumar.773124'
const gitLink = 'https://github.com/techdev-pranav'
const twitterLink = 'https://twitter.com/pk171999'
const linkedInLink = 'https://www.linkedin.com/in/pk-pranav/'


export default {
    instaLink,
    fbLink,
    gitLink,
    twitterLink,
    linkedInLink
}